import React from 'react'
import ReactApexChart from 'react-apexcharts'

class PieChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [
                this.props.cvs,
                this.props.offers,
                this.props.joined,
                this.props.notJoined,
                this.props.rejected,
                this.props.noCvs
            ],
            options: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            name: {
                                show: true
                            },
                            value: {
                                show: true
                            }
                        }
                    }
                },
                chart: {
                    type: 'donut',
                },
                labels: ['Cvs Submitted', 'Offers Released', 'Joined', 'Not Joined', 'Rejected', 'No Cvs'],
                colors: ['#FF9B52', '#3F9AE0', '#2BC155', '#FF0000', '#B576FF', '#FD5F76'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        };
    }

    render() {
        return (
            <div id="chart">
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="donut"
                    height={250}
                />
            </div>
        );
    }
}

export default PieChart